import { useQuery } from "@apollo/client/react";
import { Loader } from "@components/loader";
import { VALIDATE_LIVE_MENU_ROUTE } from "@queries/index";
import { ReactNode } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ForbiddenPage from "@pages/forbidden";

type ValidateLiveMenuRouteInput = {
  appId?: string;
  menuId: string | null;
};

export const PublishedAppRouteGate = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const menuId = searchParams.get("menuId");
  const { appId } = useParams<{ appId: string }>();

  const { data, loading, error } = useQuery<
    { validateLiveMenuRoute: { allowed: boolean } },
    { input: ValidateLiveMenuRouteInput }
  >(VALIDATE_LIVE_MENU_ROUTE, {
    variables: {
      input: {
        appId,
        menuId,
      },
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  if (error) {
    return <ForbiddenPage />;
  }

  // Only block on the initial fetch. Once we have a (possibly cached) result,
  // render children while any background revalidation runs — this stops the
  // center loader from flashing on every navigation/StrictMode remount.
  if (!data) {
    if (loading) {
      return <Loader variant="full-screen-static" className="w-100 h-100vh-50px" />;
    }
    return <ForbiddenPage />;
  }

  return children;
};
